import React from 'react';
import {Text} from 'wix-ui-tpa';
import {classes} from './ShippingSectionOverride.st.css';

export interface ShippingSectionTextProps {
  dataHook: string;
  text: string;
  isTitle?: boolean;
}

export const ShippingSectionText: React.FC<ShippingSectionTextProps> = ({dataHook, text, isTitle = false}) => {
  const textClassName = isTitle ? classes.title : classes.text;

  return (
    <div className={isTitle ? classes.wrapper : ''}>
      <Text className={textClassName} data-hook={dataHook}>
        {text}
      </Text>
    </div>
  );
};
